<form
  [formGroup]="form"
  fxLayout
  fxLayoutGap="16px"
  fxLayoutAlign=" center center"
>
  <mat-form-field fxFlex="30" *ngIf="!quickSearch">
    <mat-label>When</mat-label>
    <mat-select formControlName="operation" required>
      <mat-option
        *ngFor="let operation of form.value.filter?.operations"
        [value]="operation.value"
      >
        {{ operation.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <ng-container *ngIf="form.value.operation === 'isset'; else valueSetting">
    <mat-radio-group formControlName="value">
      <mat-radio-button [value]="'true'"> Setted </mat-radio-button>
      <mat-radio-button [value]="'false'"> Not Setted </mat-radio-button>
    </mat-radio-group>
  </ng-container>
  <ng-template #valueSetting>
    <mat-form-field [fxFlex]="quickSearch ? 100 : 70">
      <mat-label>{{ form.value.filter?.label }}</mat-label>
      <ng-container [ngSwitch]="form.value.filter?.type">
        <input
          *ngSwitchCase="'number'"
          matInput
          type="number"
          formControlName="value"
          (keydown.enter)="propagateChange()"
          required
        />
        <mat-select *ngSwitchCase="'list'" formControlName="value" required>
          <mat-option
            *ngFor="let resource of form.value.filter.resources"
            [value]="resource.value"
            >{{ resource.label }}</mat-option
          >
        </mat-select>
        <mat-select *ngSwitchCase="'boolean'" formControlName="value" required>
          <mat-option value="true">Yes</mat-option>
          <mat-option value="false">No</mat-option>
        </mat-select>
        <mat-select
          *ngSwitchCase="'resourceList'"
          formControlName="value"
          required
        >
          <mat-option
            *ngFor="let resource of form.value.filter.resources$ | async"
            [value]="resource.id"
            >{{ resource.name | translate }}</mat-option
          >
        </mat-select>
        <mat-select *ngSwitchCase="'enumList'" formControlName="value" required>
          <mat-option
            *ngFor="let resource of form.value.filter.resources$ | async"
            [value]="resource.code"
            >{{ resource.label }}</mat-option
          >
        </mat-select>
        <div *ngSwitchCase="'date'" style="display: flex; align-items: center; cursor: pointer;" (click)="picker.open()">
          <input
            matInput
            [matDatepicker]="picker"
            formControlName="value"
            required
            style="flex: 1; pointer-events: none;"
          readonly
          />
          <mat-datepicker-toggle [for]="picker" style="position: absolute; right: 0;"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>

        <input
          *ngSwitchDefault
          matInput
          formControlName="value"
          (keydown.enter)="propagateChange()"
          required
        />
      </ng-container>
    </mat-form-field>
  </ng-template>
</form>
